export default __webpack_public_path__ + "static/media/Search.a3055166.svg";